// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__lejSw","footer":"ModalFilter_footer__288kM"};